import React, { useEffect } from 'react';
import { Container, Row, Col, Form, Button, Alert } from 'react-bootstrap';
import { supabase } from '../lib/supabaseClient';

export default function PasswordReset() {
  const [email, setEmail] = React.useState('');
  const [status, setStatus] = React.useState({ ok: false, msg: '' });
  const [busy, setBusy] = React.useState(false);

  useEffect(() => {
    document.title = "Send Password Reset | TheSkinnyAI";
    const canonicalLink = document.querySelector("link[rel='canonical']");
    if (canonicalLink) {
      canonicalLink.setAttribute("href", "https://theskinnyai.com/password-reset");
    } else {
      const link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      link.setAttribute("href", "https://theskinnyai.com/password-reset");
      document.head.appendChild(link);
    }
    // Update og:url to match canonical
    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) {
      ogUrl.setAttribute("content", "https://theskinnyai.com/password-reset");
    }
  }, []);

  async function send() {
    setStatus({ ok: false, msg: '' });
    setBusy(true);
    try {
      if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
        setStatus({ ok: false, msg: 'Please enter a valid email.' });
        return;
      }
      const { error } = await supabase.auth.resetPasswordForEmail(email, { redirectTo: `${window.location.origin}/update-password` });
      if (error) throw error;
      setStatus({ ok: true, msg: 'Password reset email sent. Please check your inbox.' });
    } catch (e) {
      setStatus({ ok: false, msg: e?.message || String(e) });
    } finally {
      setBusy(false);
    }
  }

  return (
    <Container className="py-4">
      <Row className="justify-content-center">
        <Col md={6} lg={5}>
          <h3>Send Password Reset</h3>
          {status.msg ? (
            <Alert variant={status.ok ? 'success' : 'danger'} className="mt-3">{status.msg}</Alert>
          ) : null}
          <Form className="mt-3" onSubmit={(e) => { e.preventDefault(); send(); }}>
            <Form.Group>
              <Form.Label>Email</Form.Label>
              <Form.Control type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" />
            </Form.Group>
            <Button className="mt-3" disabled={busy} onClick={send}>{busy ? 'Sending…' : 'Send Reset Email'}</Button>
          </Form>
        </Col>
      </Row>
    </Container>
  );
}


